module.exports = __webpack_public_path__ + "img/register-v2-dark.a5a07594.svg";